import * as React from "react";
import {AppState} from "../components/app/app-mobx";
import {MapViewerConfiguration} from "../config/map-viewer-configuration";
import {NavigationConfiguration} from "../config/navigation-configuration";

import {autorun} from "mobx";
import {Auftragsverwaltung} from "../stores/auftragsverwaltung-mobx";

export interface FaqProps {
    appStore: AppState;
    auftragsverwaltung: Auftragsverwaltung;
    view: __esri.MapView | __esri.SceneView | undefined;
    mapViewerConfig: MapViewerConfiguration;
}

export class Faq extends React.Component<FaqProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    constructor(props: FaqProps) {
        super(props);
        this.state = {};
    }
    componentDidMount(): void {
        const {appStore, auftragsverwaltung} = this.props;
        const breadcrumbs = new NavigationConfiguration();
        breadcrumbs.items = [
            { title: "FAQ" }
        ];
        appStore.setBreadcrumbs(breadcrumbs);
        appStore.setPageTitle("Häufig gestellte Fragen");
        appStore.setShowAside(true);
        appStore.setAsideContent(null);
        auftragsverwaltung.setShowMap(false);
        autorun((reaction: any) => {
            const {view} = this.props;
            if (!view) {
                return;
            }
            reaction.dispose();
        });
        this.autorunDisposers.push(autorun((reaction: any) => {
            
        }));
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
    }
    render(): React.ReactElement | null {
        return(
            <div className={"faq"}>
                <ul>
                    <li><h3>Welche Grundstücke sind im Informationssystem objekt.lu abfragbar?</h3>
                        <p>Abgefragt werden können Liegenschaften sowie selbständige und dauernde Rechte
                            (wie Baurechte). Nicht unterstützt werden Grundstücke, die nicht in der amtlichen Vermessung
                            geführt werden, wie z.B. Stockwerkeigentum.</p>
                    </li>
                    <li><h3>Welche Gebäude sind im Informationssystem objekt.lu abfragbar?</h3>
                        <p>Es können sämtliche adressierten Objekte abgefragt werden. Bis Ende 2022 wird das GWR um
                            sämtliche Nicht-Wohngebäude erweitert, welche anschliessend ebenfalls verfügbar sind.</p>
                    </li>
                    <li><h3>Warum werden bei der Suche teilweise mehrere Objekte gleichzeitig ausgewiesen?</h3>
                        <p>Die Datenbestände von kGWR, Baugesuchsverwaltung eBaGePlus und amtlicher Vermessung (AV) sind
                            aufgrund nicht vollständig gleichgeschalteter Prozesse nicht zu 100% synchronisiert:</p>
                        <ul>
                            <li>während ein projektiertes Objekt im kGWR und in eBaGePlus ab dem Zeitpunkt der
                                Ersterfassung geführt wird, wird es in der AV erst mit erteilter Baubewilligung als
                                projektiertes Objekt erfasst.</li>
                            <li>eine Baubewilligung ist 2 Jahre gültig und kann verlängert werden, die Nachführung in
                                der AV (als bestehendes Objekt) erfolgt erst nach Bauvollendung.</li>
                        </ul>
                    </li>
                    <li><h3>Wie nutze ich das Informationssystem Objektwesen?</h3>
                        <p className={"richtext"}>
                            <a href={"./files/03_objekt.lu_Benutzeranleitung_Informationssystem_210624.pdf"}
                                className={"pdf"} target={"_blank"} rel="noreferrer">
                                <span className={"linked"}>Benutzeranleitung Informationssystem</span></a>
                        </p>
                    </li>
                </ul>
            </div>
        );
    }
}
